import { Component, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsSettingsEvent } from 'analytics-api';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { ContextService } from 'idt-ecommerce-api/context/context.service';
import { StoresHelpers } from 'idt-ecommerce-api/stores/stores.helpers';
import { StoreSummary, StoreLanguage } from 'idt-ecommerce-api/stores/stores.models';
import { RenderEvent } from 'render/render-events/render-events.model';
import { RenderEventsService } from 'render/render-events/render-events.service';
import { RenderSlugService } from 'render/services/render-slug.service';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { combineLatest } from 'rxjs';

import {
  PieceSelectStoreLanguageSettings
} from 'extensions/core/piece-select-store-language/front/models/piece-select-store-language.models';


@Component({
  selector: 'piece-select-store-language-render',
  templateUrl: './piece-select-store-language-render.component.html',
  styleUrls: ['./piece-select-store-language-render.component.scss']
})
export class PieceSelectStoreLanguageRenderComponent
  extends BaseRenderComponent<PieceSelectStoreLanguageSettings>
  implements OnInit, OnDestroy {

  public stores: StoreSummary[] = [];
  public languages: StoreLanguage[] = [];
  public selectedStore: StoreSummary | null = null;
  public selectedLanguage: StoreLanguage | null = null;
  public analyticsEventChangeLanguage: string = '';
  public analyticsEventChangeRegion: string = '';
  public languageSetted: boolean = false;
  constructor(
    private readonly contextService: ContextService,
    private readonly cd: ChangeDetectorRef,
    private readonly renderSlugService: RenderSlugService,
    private readonly renderStateService: RenderStateService,
    private readonly renderEventsService: RenderEventsService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.initStores();
    if (isDefined(this.settings.analytics)) {
      this.setAnalyticsEvents();
    }
  }

  public initStores(): void {
    combineLatest([
      this.contextService.getAllStores$(),
      this.contextService.getCurrentLanguage$()
    ]).subscribe((storeData: [StoreSummary[], StoreLanguage]) => {
      const [stores, language] = storeData;
      this.stores = stores;
      if (this.stores.length > 0) {
        let selectedStore;
        if (this.country) {
          selectedStore = StoresHelpers.getStoreByCountryCode(stores, this.country);
        }
        const countryCode = selectedStore ? selectedStore.countryCode : stores[0].countryCode;
        this.setStoreAndLanguages(countryCode);
        if (isDefined(language) && !this.languageSetted) {
          this.selectLanguage(language.code);
        }
        this.cd.markForCheck();
      } else {
        this.selectStore(null);
      }
    });
  }

  public selectStore(event: Event | null) {
    const countryCode = event?.target as HTMLSelectElement;
    this.setStoreAndLanguages(countryCode?.value);
    this.setCurrentLanguage();
    this.cd.markForCheck();
  }

  public onChangeLanguage(event: Event | null) {
    const languageOption = event?.target as HTMLSelectElement;
    this.selectLanguage(languageOption?.value);
  }

  public goToHome(event: Event) {
    if (isDefined(this.selectedStore) && isDefined(this.selectedLanguage)) {
      const slug = this.renderSlugService.getSlug();
      const country = this.selectedStore.countryCode;
      const lang = this.selectedLanguage.code;
      this.renderStateService.setStoreInfo(slug, { country, lang });

      const renderEvent = {
        event,
        extra: {
          type: 'languageChange',
          country,
          lang
        }
      } as RenderEvent;
      this.renderEventsService.events.next(renderEvent);
    }
  }

  public navigateToWorldwide(event: Event) {
    const renderEvent = {
      event,
      extra: {
        type: 'section',
        section: 'worldwide'
      }
    } as RenderEvent;
    this.renderEventsService.events.next(renderEvent);
  }

  public clickLanguage(event: Event, codeLanguage: string) {
    if (this.selectedLanguage && this.selectedLanguage.code !== codeLanguage) {
      this.selectedLanguage = this.languages.find((language) => language.code === codeLanguage) || null;
      this.languageSetted = true;
      this.goToHome(event);
    }
  }

  public setAnalyticsEvents() {
    const eventChangeLanguageInfo = this.settings.analytics?.events.find((ev: AnalyticsSettingsEvent) => ev.name === 'changeLanguage');
    const eventChangeCountryInfo = this.settings.analytics?.events.find((ev: AnalyticsSettingsEvent) => ev.name === 'changeCountry');
    this.analyticsEventChangeLanguage = eventChangeLanguageInfo?.relatedEvent || '';
    this.analyticsEventChangeRegion = eventChangeCountryInfo?.relatedEvent || '';
  }

  public trackByStore(index: number, item: StoreSummary): string {
    return item.id;
  }

  public trackByLanguage(index: number, item: StoreLanguage): string {
    return item.id;
  }

  private selectLanguage(languageCode: string | null) {
    if (isDefined(languageCode) && isDefined(this.selectedStore)) {
      this.selectedLanguage = StoresHelpers.getSupportedLanguageByCode(this.selectedStore, languageCode) || null;
    } else {
      this.selectedLanguage = null;
    }
  }

  private setStoreAndLanguages(countryCode: string | null) {
    if (isDefined(countryCode)) {
      this.selectedStore = StoresHelpers.getStoreByCountryCode(this.stores, countryCode) || null;
      this.languages = isDefined(this.selectedStore) ? this.selectedStore.supportedLanguages : [];
    } else {
      this.selectedStore = null;
      this.languages = [];
    }
  }

  private setCurrentLanguage() {
    if (this.languages.length > 0) {
      let selectedLanguage;
      if (this.lang) {
        selectedLanguage = this.languages.find((language) => language.id === this.lang);
      }
      this.selectLanguage(selectedLanguage ? selectedLanguage.code : this.languages[0].code);
    } else {
      // Si no hay idiomas, deseleccionamos el idoma que pudiese estar seleccionado
      this.selectLanguage(null);
    }
  }

}
